import { useLanguage } from '../../context/LanguageContext';
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import authService from '../../services/auth.service';
import LoadingSpinner from '../../components/common/LoadingSpinner';

const VerifyEmailPage = () => {
  const { t } = useLanguage();
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        await authService.verifyEmail(token);
        setSuccess(true);
      } catch (err) {
        setError(err.response?.data?.message || 'Verification failed. The link may have expired.');
      } finally {
        setLoading(false);
      }
    };
    verifyEmail();
  }, [token]);

  if (loading) return <LoadingSpinner />;

  return (
    <div className="section-padding d-flex align-items-center justify-content-center" style={{ minHeight: '70vh' }}>
      <div className="text-center" style={{ maxWidth: '420px' }}>
        {success ? (
          <>
            <FiCheckCircle size={56} className="text-success mb-3" />
            <h3>Email Verified!</h3>
            <p className="text-muted">
              Your email has been verified successfully. You can now access all features.
            </p>
            <Link to="/" className="btn btn-fd-primary mt-3">Go to Home</Link>
          </>
        ) : (
          <>
            <FiAlertCircle size={56} className="text-danger mb-3" />
            <h3>Verification Failed</h3>
            <p className="text-muted">{error}</p>
            <Link to="/login" className="btn btn-fd-primary mt-3">Go to Login</Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
